/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { config } from '@app/config/app';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  load(): Promise<void> {
    return new Promise((resolve) => {
      const clarity = (window as any).clarity;

      if (clarity) {
        resolve();
        return;
      }

      const projectId = config.clarityID;

      // If no Project ID → just resolve and skip Clarity
      if (!projectId) {
        console.warn('Clarity disabled: no Project ID configured for this environment');
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${projectId}`;

      script.onload = () => resolve();
      script.onerror = () => {
        console.error('Failed to load Clarity script');
        resolve(); // still resolve so app flow doesn’t break
      };

      document.head.appendChild(script);
    });
  }

  setTag(key: string, value: string): void {
    const clarity = (window as any).clarity;
    if (clarity) {
      clarity('set', key, value);
    }
  }

  identify(userId: string): void {
    const clarity = (window as any).clarity;
    if (clarity) {
      clarity('identify', userId);
    }
  }

  stop(): void {
    const clarity = (window as any).clarity;
    if (clarity) {
      clarity('stop');
    }
  }

  start(projectId: string): void {
    const clarity = (window as any).clarity;
    if (clarity) {
      clarity('start', { projectId });
    }
  }
}
